<template>
    <div>
    	<table class="room-table" cellspacing="0" v-if="!isLoading">
            <tbody>
                <tr style="text-align: left;vertical-align: top;">
                    <td class="roomType">{{rps.PriceTypeName+'&nbsp;&nbsp;'+"< " + (rps.EnRatePlanName||rps.RatePlanName) + " >"}}</td>
                    <td  class="roomStatus">
                        <p>Status</p>
                        <p>{{inpStatus?"Inventory":''}}</p>
                        <div style="height: 10px;"></div>
                        <p>{{inpPrice?"Room Rate":''}}</p>
                        <p>{{inpRule?"CXL Policy":''}}</p>
                    </td>
                    <td :class="(getDaysSize(today,day.PD)>=0&&day.S!='026001'&&day.S)?'change-room roomItem close':'change-room roomItem'" v-for="day in tableData" @click="toRoomStatusSingleEdit(day)">
                        <div v-if="day" class="roomContent" style="cursor: default;">
                            <!-- <i v-if="getDaysSize(today,day.PD)>=0&&day.S!='026001'&&day.S"></i> -->
                            <div v-if="day.A" class="roomNum">
                                <p v-if="day.S=='026001'" class="roomOpen">Open</p>
                                <p v-else-if="day.S&&day.S!='026001'" class="roomClose">Close</p>
                                <p v-else class="roomWait">None</p>
                                <p>
                                    <span v-if="inpStatus" style="color: #a48cfd;"> R </span>
                                    <label  v-if="day.O==false&&day.O!=null&&inpStatus">(Cannot)</label>
                                    <span class="one"  v-if="day.O&&inpStatus">(Can)</span>
                                </p>
                            </div>
                            <div v-if="!day.A" class="roomNum">
                                <p v-if="day.S=='026001'" class="roomOpen">Open</p>
                                <p v-else-if="day.S&&day.S!='026001'" class="roomClose">Close</p>
                                <p v-else class="roomWait">None</p>
                                <p>
                                    <label class="size" v-show="day.SC!=null&&inpStatus">{{day.SC?day.SC:0}}</label>
                                    <label v-if="day.O==false&&day.O!=null&&inpStatus">(Cannot)</label>
                                    <span class="one" v-if="day.O&&inpStatus">(Can)</span>
                                </p>
                            </div>
                            <p>
                                <label class="size">{{inpPrice?day.AP:''}}</label>
                            </p>
                           
                            <p v-show="!day.C" class="font10">
                                <label v-show="day.CD!=null&&inpRule">{{day.CD>0?day.CD +' day ':'On day '}}</label>
                                <label v-show="day.CT&&inpRule">{{day.CT}}</label>
                            </p>
                            <p v-show="day.C&&inpRule"><span>Non-ref</span></p>
                            <!-- <span class="day">{{getDateDay(day.PD)}}</span> -->
                        </div>
                        <div class="roomContent" v-else> </div>
                    </td>
                </tr>
            </tbody>
        </table>
 
    </div>

</template>
<script>


export default {
    name:'statusAndPriceTable',

    props:{
        rps:{
            type:Object,
            default:function(){
                return{}
            }
        },
        beginSlot:{
            type: String,
            default:''
        },
        inpPrice:{
            type: Boolean,
            default:true
        },
        inpStatus:{
            type: Boolean,
            default:true
        },
        inpRule:{
            type: Boolean,
            default:true
        },
        
    },
    data(){
        return{
            cmRps:{},
            tableData:'',
            cmSingleData: {},
            today:this.getDate(0),
            begin:this.getDate(0),
            isLoading:true
        }
    },
    watch:{
        beginSlot(val){
            this.begin = val
            this.initDate()
        },
        rps(val){
            console.log(val)
            this.cmRps=val;
            this.initTable();
        }
    },
    methods:{
        
        initDate(){
            var arr=[]
            var date =''
            for(var i = 0;i<=6; i++){
                if(i==0){
                    date = this.begin
                }else{
                    date = this.getNextDay(this.begin,i)
                }
                arr.push(date)
            }
            this.$emit('select',this.begin,arr)
            this.initTable()
        },
        //获取月份的数据
        initTable(){
            var that=this;
            var cmRps=that.cmRps;
            var params={
              hotel: cmRps.HotelId,
              room: cmRps.RoomId,
              rp: cmRps.RatePlanId,
              rate: cmRps.RateId,
              date: that.begin.replace(/-/g,''),
              endDate:that.getNextDay(that.begin,10).replace(/-/g,'')
            }
            that.isLoading = true;
            that.getRequest({
                url: that.Api.getRp,
                params: params
            }).then(res => {
                that.isLoading = false;
                if (res && res.length>0) {
                    that.tableData = res                 
                } else {
                    that.tableData='';
                    that.error({ title: 'Tips', content: 'No data is queried' });
                }
            });
        },

       
        //获取日期中的天
        getDateDay(date){
            var date=date;
            var day=date.split('/')[2];
            return day

        },
        //编辑单独一天的房态
        toRoomStatusSingleEdit(day){
            if(this.getDaysSize(this.today,day.PD)<0)return;//先判断当期日期是否可以编辑
            this.cmSingleData=day;
            this.$nextTick(function () {
                this.$set(this.cmSingleData,'isShow',this.cmSingleData.isShow?false:true);
            });
        }
    },
    mounted(){
        this.cmRps=this.rps;
        this.initDate()
    }

}
</script>












// WEBPACK FOOTER //
// src/components/RoomPriceAndStatus/psComponent/table2.vue